<template>
    <component class="icon" :is="icon" />
</template>

<script>
export default {
    props: {
        name: {
            type: String,
            default: 'download'
        },

        folder: {
            type: String
        }
    },

    computed: {
        icon ({ name }) {
            return `SVGicon-${name}`
        }
    }
}
</script>

